import { PageHead } from "@generalapplications/html-render/react";
import { useParams } from "react-router-dom";

import { CapabilityTemplate } from "@/app/pages/capabilityDetail/components/CapabilityTemplate";
import { getCapabilityBySlug } from "@/content/capabilities";
import { routes } from "@/app/common/functions/routes/routes";
import { pageHead, sectionTrail } from "@/app/common/functions/seo/pageHead";

import { NotFoundPage } from "@/app/pages/notFound/NotFoundPage";

export function CapabilityDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const capability = slug ? getCapabilityBySlug(slug) : undefined;

  if (!capability) {
    return <NotFoundPage />;
  }

  const path = routes.capabilities.detail(capability.slug);
  return (
    <>
      <PageHead
        head={pageHead({
          path,
          title: capability.seoTitle,
          description: capability.seoDescription,
          imagePath: capability.image,
          breadcrumbs: sectionTrail(
            { name: "Capabilities", path: routes.capabilities.index },
            { name: capability.title, path },
          ),
        })}
      />
      <CapabilityTemplate capability={capability} />
    </>
  );
}
